var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "modal fade show in", attrs: { id: "fellowModal" } },
      [
        _vm.loading
          ? _c("div", { attrs: { id: "loading" } }, [
              _c("img", {
                attrs: { src: "/images/watson-loading.gif", alt: "Loading" }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.tjModalVisible
          ? _c("tj-modal", {
              attrs: {
                "selected-fellow": _vm.selectedFellow,
                continents: _vm.continents
              },
              on: {
                "close-modal": function($event) {
                  _vm.closeModal()
                },
                loaded: function($event) {
                  _vm.loading = false
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.jkModalVisible
          ? _c("jk-modal", {
              attrs: { "selected-fellow": _vm.selectedFellow },
              on: {
                "close-modal": function($event) {
                  _vm.closeModal()
                }
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc7bdd70", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc7bdd70","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/modal.vue
// module id = 394
// module chunks = 0